import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
const TONE_COLOR = {
    default: 'var(--fg-1)',
    pass: 'var(--status-pass-text)',
    warn: 'var(--status-warn-text)',
    fail: 'var(--status-fail-text)',
    accent: 'var(--garnet-text)',
};
export function Stat({ label, value, unit, tone = 'default', mono = true }) {
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 2 }, children: [_jsx("span", { className: "label", style: { fontSize: 9 }, children: label }), _jsxs("span", { className: cx(mono && 'mono'), style: { fontSize: 18, color: TONE_COLOR[tone], fontWeight: 500, letterSpacing: '-0.01em' }, children: [value, unit && _jsx("span", { style: { fontSize: 11, color: 'var(--fg-3)', marginLeft: 2 }, children: unit })] })] }));
}
//# sourceMappingURL=Stat.js.map